import { getDetailsTabRouteObjects } from '../../../utility/route';

import Catalog from '@catalog/catalog';

import ArtistsList from '../components/artists/artists-list';
import LabelsList from '../components/labels/labels-list';
import ProjectsList from '../components/projects/projects-list';
import ReleaseList from '../components/releases/releases-list';
import ProductsList from '../components/products/products-list';
import TracksList from '../components/tracks/tracks-list';
import ProductGroupsList from '../components/product_groups/product_groups-list';
import CatalogPlugin from '../components/plugin/plugin';
// import Statement from '../components/statements/statements';
// import StatementList from '../components/statements/statement-list';
// import Payments from '../components/statements/payments';
// import CheckList from '../components/statements/checklist'

import {
  catalogArtistListLDTRoutes,
  labelsListLDTRoutes,
  projectsListLDTRoutes,
  releasesListLDTRoutes,
  productsListLDTRoutes,
  tracksListLDTRoutes,
  productGroupsLDTRoutes,
 // statementsListLDTRoutes,
} from './routes';

export default [{
  path: "/main/catalog",
  name: "catalog",
  component: Catalog,
  redirect: "main/catalog/products",
  children: [
    ...getDetailsTabRouteObjects(catalogArtistListLDTRoutes, ArtistsList),
    ...getDetailsTabRouteObjects(labelsListLDTRoutes, LabelsList),
    ...getDetailsTabRouteObjects(projectsListLDTRoutes, ProjectsList),
    ...getDetailsTabRouteObjects(releasesListLDTRoutes, ReleaseList),
    ...getDetailsTabRouteObjects(productsListLDTRoutes, ProductsList),
    ...getDetailsTabRouteObjects(tracksListLDTRoutes, TracksList),
    ...getDetailsTabRouteObjects(productGroupsLDTRoutes, ProductGroupsList),
    //...getDetailsTabRouteObjects(statementsListLDTRoutes, StatementList),
    {
      name: 'catalog_plugins',
      path: "plugins",
      component: CatalogPlugin
    },

  ],
},];